import { createSlice } from '@reduxjs/toolkit';

const initialState = { image: null };
const previewSlice = createSlice({
    name: 'preview',
    initialState,
    reducers: {
        addImage: (state, action) => ({ image: { ...action.payload } }),
        clearImage: (state, action) => ({ image: null })
    }
});

export const { addImage, clearImage } = previewSlice.actions;

export default previewSlice.reducer;
